import React, { useEffect, useState, useContext } from "react";
import { useAlert } from 'react-alert';
import { UserContext } from "../../UserContext";
import { useNavigate } from "react-router-dom";
import CenteredPageContainer from "../components/layout_components/CenteredPageContainer";
import CardLayout from "../components/layout_components/CardLayout";
import { TextInput, SelectInput } from "../components/common_components/Forms";
import Button from "../components/common_components/Button";
import CenteredLoadingIcon from "../components/common_components/CenteredLoadingIcon";

import TimezoneList from "../../preauth_portal/components/TimezoneList";

// API Calls
import BoosterAPI from "../api/api_calls/BoosterAPI";



function Boosters(props) {
    const { user, setUser, refreshUser } = useContext(UserContext);
    const alert = useAlert();

    const [boosters, setBoosters] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchBoosters = async () => {
            const data = await BoosterAPI.index();
            setBoosters(data.boosters);
            setLoading(false);
        }
        fetchBoosters();
        document.title = 'Boosters | Despark';
    }, []);



    return (
        <CenteredPageContainer>
            <CardLayout>
                <div className="profile-header-container">
                    <h1>Profile Boosters</h1>
                    <div className="body-small black-500-text">
                        Profile Boosters help us match you with relevant missions and maximize your chances of getting approved for high-value missions.
                    </div>
                </div>
                {loading ? <CenteredLoadingIcon /> :
                    <div className="booster-cards-container">
                        {
                            boosters.map((booster) => (
                                <BoosterCard key={booster.name} name={booster.name} complete={booster.complete} link={booster.link} lengthInMinutes={booster.length_in_minutes} />
                            ))
                        }
                    </div>
                }
            </CardLayout>
        </CenteredPageContainer>
    )
}

function BoosterCard({ name, complete, link, lengthInMinutes = 3, ...props }) {
    const navigate = useNavigate();
    return (
        <div className="booster-card" onClick={() => { navigate(link) }}>
            <div className="booster-card-name-and-notes">
                <div className="booster-card-name body-large">
                    {name}
                </div>
                {complete ?
                    <div className="booster-card-edit-notes-text">
                        Edit responses
                    </div>
                    :
                    <div className="booster-card-time-container">
                        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M9 4.2V9L12.2 10.6M17 9C17 13.4183 13.4183 17 9 17C4.58172 17 1 13.4183 1 9C1 4.58172 4.58172 1 9 1C13.4183 1 17 4.58172 17 9Z" stroke="#BFBFBF" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                        <div className="booster-card-time-text">
                            Takes {lengthInMinutes} minutes
                        </div>
                    </div>
                }
            </div>
            <div className="booster-card-actions">
                {complete ?
                    <div className="booster-card-complete-container">
                        <div className="booster-card-complete-text body-small">
                            Completed
                        </div>
                        <svg xmlns="http://www.w3.org/2000/svg" width="28" height="29" viewBox="0 0 28 29" fill="none">
                            <rect y="0.5" width="28" height="28" rx="14" fill="#8248FC" />
                            <path d="M8 14.5L11.8 18.3L19.1 11" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </div>
                    :
                    <Button size="small" onClick={() => { navigate(link) }}>
                        Get started
                    </Button>
                }
            </div>
        </div>
    )
}


export default Boosters